import React from 'react'

const IconEnvelope = ({ height, modifiers }) => {
  return (
    <svg
      className={`icon icon-envelope ${modifiers}`}
      style={{height}}
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 225.4 159.9"
    >
      <path d="M172.7,20l-54,47.9c-2.2,2-4.5,2.4-6,2.4c-1.5,0-3.8-0.4-6-2.4L52.7,20H172.7 M202.8,0H22.5
			c-0.4,0-0.8,0-1.1,0c-0.1,0-0.3,0-0.4,0c-0.2,0-0.5,0-0.7,0.1c-0.2,0-0.3,0-0.5,0.1c-0.2,0-0.4,0.1-0.6,0.1
			c-0.2,0-0.3,0.1-0.5,0.1c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0-0.3,0.1-0.5,0.1c-0.2,0.1-0.4,0.1-0.6,0.2
			C16.3,0.9,16.2,1,16,1c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0-0.3,0.1-0.4,0.2c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1,0.1-0.3,0.1-0.4,0.2
			c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.1-0.4,0.2-0.7,0.4
			c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.1-0.4,0.3-0.7,0.4c-0.1,0-0.1,0.1-0.2,0.1C10.1,4,9.9,4.1,9.7,4.3c-0.1,0-0.1,0.1-0.2,0.1
			C9.3,4.6,9.1,4.8,8.8,5c0,0-0.1,0.1-0.1,0.1C8.5,5.3,8.3,5.5,8,5.7c0,0,0,0-0.1,0.1C7.7,6,7.5,6.2,7.2,6.4c0,0,0,0,0,0v0
			C2.8,10.8,0,17.1,0,24v111.9c0,6.9,2.8,13.2,7.2,17.6v0c0,0,0,0,0,0c0.2,0.2,0.5,0.5,0.7,0.7c0,0,0,0,0.1,0.1
			c0.2,0.2,0.5,0.4,0.7,0.6c0,0,0.1,0.1,0.1,0.1c0.2,0.2,0.5,0.4,0.7,0.5c0.1,0,0.1,0.1,0.2,0.1c0.2,0.2,0.4,0.3,0.7,0.5
			c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.4,0.3,0.7,0.4c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.1,0.4,0.3,0.7,0.4c0.1,0.1,0.2,0.1,0.3,0.2
			c0.2,0.1,0.4,0.2,0.6,0.3c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.1,0.4,0.2,0.6,0.3c0.1,0.1,0.2,0.1,0.4,0.2c0.2,0.1,0.4,0.2,0.6,0.2
			c0.1,0.1,0.3,0.1,0.4,0.2c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0,0.3,0.1,0.5,0.1c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0,0.3,0.1,0.5,0.1
			c0.2,0,0.4,0.1,0.6,0.1c0.2,0,0.4,0.1,0.6,0.1c0.2,0,0.3,0.1,0.5,0.1c0.2,0,0.4,0.1,0.6,0.1c0.2,0,0.3,0,0.5,0.1
			c0.2,0,0.5,0,0.7,0.1c0.1,0,0.3,0,0.4,0c0.4,0,0.7,0,1.1,0h180.3c0.4,0,0.8,0,1.1,0c0.1,0,0.3,0,0.4,0c0.2,0,0.5,0,0.7-0.1
			c0.2,0,0.3,0,0.5-0.1c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.3-0.1,0.5-0.1c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4-0.1,0.6-0.1
			c0.2,0,0.3-0.1,0.5-0.1c0.2-0.1,0.4-0.1,0.6-0.2c0.2,0,0.3-0.1,0.5-0.1c0.2-0.1,0.4-0.1,0.6-0.2c0.1,0,0.3-0.1,0.4-0.2
			c0.2-0.1,0.4-0.2,0.6-0.2c0.1-0.1,0.3-0.1,0.4-0.2c0.2-0.1,0.4-0.2,0.6-0.3c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.2,0.6-0.3
			c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.2,0.7-0.4c0.1-0.1,0.2-0.1,0.2-0.2c0.2-0.1,0.4-0.3,0.7-0.4c0.1,0,0.1-0.1,0.2-0.1
			c0.2-0.2,0.5-0.3,0.7-0.5c0.1,0,0.1-0.1,0.2-0.1c0.2-0.2,0.5-0.4,0.7-0.5c0,0,0.1-0.1,0.1-0.1c0.2-0.2,0.5-0.4,0.7-0.6
			c0,0,0,0,0.1-0.1c4.9-4.4,8-11,8-18.3V24c0-7.3-3.1-13.8-8-18.3c0,0,0,0-0.1-0.1c-0.2-0.2-0.5-0.4-0.7-0.6c0,0-0.1-0.1-0.1-0.1
			c-0.2-0.2-0.5-0.4-0.7-0.5c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.2-0.4-0.3-0.7-0.5c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.7-0.4
			c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.4-0.3-0.7-0.4c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1-0.1-0.2-0.1-0.3-0.2
			c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2-0.1-0.4-0.2-0.6-0.2c-0.1-0.1-0.3-0.1-0.4-0.2c-0.2-0.1-0.4-0.1-0.6-0.2
			c-0.2,0-0.3-0.1-0.5-0.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.2,0-0.4-0.1-0.6-0.1
			c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.2,0-0.3,0-0.5-0.1c-0.2,0-0.5,0-0.7-0.1c-0.1,0-0.3,0-0.4,0
			C203.6,0,203.2,0,202.8,0L202.8,0z M112.7,90.3c6.8,0,13.7-2.5,19.2-7.4l74.4-66c2.4,1.4,4.1,4,4.1,7.1v111.9c0,3-1.7,5.7-4.1,7.1
			l-65.2-57.8l-4.4,3.9c-2.6,2.3-5.4,4.2-8.4,5.6l55.5,49.3H41.5L97,94.6c-3-1.5-5.8-3.3-8.4-5.6l-4.4-3.9L19.1,143
			c-2.4-1.4-4.1-4-4.1-7.1V24c0-3,1.7-5.7,4.1-7.1l74.4,66C99,87.8,105.8,90.3,112.7,90.3L112.7,90.3z"/>
    </svg>
  )
}

IconEnvelope.defaultProps = {
  height: "5rem",
  modifiers: "",
}

export default IconEnvelope
